/**
 * stat.js
 * 统计、埋点
 */

/*
ext:
 stat.init({bridge: new Bridge()});
 stat.send({name:"事件名称",properties{key:value}});
 */

import Bridge from '../../lib/Bridge'
import { getRunningEnv, getPlatform } from '../../tools/getPlatform'
import { pick } from '../../tools/objOperation'
import ZHUGEKEYS from './zhugeIO_keys'

class stat {
  constructor({
    platform,
    globalParams = {},
    interceptor,
    customTrackConfig = {}
  } = {}) {
    console.log('初始化 Stat 对象：', platform, globalParams)
    this.platform = getPlatform()
    this.curPlatform = platform || ''
    this.runningEnv = getRunningEnv()
    this.bridge = new Bridge()
    this.globalParams = globalParams
    this.interceptor = interceptor
    this.zhugeSDK(platform, customTrackConfig)
  }
  init() {
    // 兼容旧代码的init方法写法
    return this
  }

  setGlobalParams(globalParams = {}) {
    this.globalParams = Object.assign(this.globalParams, globalParams)
  }

  zhugeSDK(platform, sdkConfig) {
    if (window.zhuge) return
    window.zhuge = window.zhuge || []
    window.zhuge.methods = '_init debug identify track getDid getSid getKey setSuperProperty setUserProperties setWxProperties setPlatform'.split(
      ' '
    )
    // window.zhuge.methods = '_init debug identify track trackLink trackForm page'.split(' ');
    window.zhuge.factory = function(b) {
      return function() {
        var a = Array.prototype.slice.call(arguments)
        a.unshift(b)
        window.zhuge.push(a)
        return window.zhuge
      }
    }
    for (var i = 0; i < window.zhuge.methods.length; i++) {
      var key = window.zhuge.methods[i]
      window.zhuge[key] = window.zhuge.factory(key)
    }
    window.zhuge.load = function(b, x) {
      if (!document.getElementById('zhuge-js')) {
        var a = document.createElement('script')
        var verDate = new Date()
        var verStr =
          verDate.getFullYear().toString() +
          verDate.getMonth().toString() +
          verDate.getDate().toString()

        a.type = 'text/javascript'
        a.id = 'zhuge-js'
        a.async = !0
        // 更新诸葛SDK地址：http://docs.zhugeio.com/dev/js.html
        a.src =
          (location.protocol == 'http:'
            ? 'http://sdk.zhugeio.com/zhuge.min.js?v='
            : 'https://zgsdk.zhugeio.com/zhuge.min.js?v=') + verStr
        a.onerror = function() {
          window.zhuge.identify = window.zhuge.track = function(
            ename,
            props,
            callback
          ) {
            if (
              callback &&
              Object.prototype.toString.call(callback) === '[object Function]'
            ) {
              callback()
            } else if (
              Object.prototype.toString.call(props) === '[object Function]'
            ) {
              props()
            }
          }
        }
        var c = document.getElementsByTagName('script')[0]
        c.parentNode.insertBefore(a, c)
        window.zhuge._init(b, x)
      }
    }

    // 配置应用的AppKey
    // 根据 WEBPACK_DEV 开启是否debug，不用每次都进行开关
    // 正式环境且是生产模式，不debug
    let useKey
    let localPlatform
    if (platform && ZHUGEKEYS[platform]) {
      useKey = ZHUGEKEYS[platform]
      localPlatform = platform
    } else {
      if (this.platform.isYixinliApp) {
        useKey = ZHUGEKEYS.yxlApp
        localPlatform = 'yxlApp'
      } else if (this.platform.isCeShiApp) {
        useKey = ZHUGEKEYS.cpApp
        localPlatform = 'cpApp'
      } else if (this.platform.isPc) {
        useKey = ZHUGEKEYS.yixinliPC
        localPlatform = 'yixinliPC'
      } else {
        useKey = ZHUGEKEYS.msite
        localPlatform = 'msite'
      }
    }

    // 取出SDK支持的配置参数
    let filtedConfig = pick(sdkConfig, [
      'superProperty',
      'adTrack',
      'zgsee',
      'autoTrack',
      'singlePage'
    ])
    console.log(
      '当前环境：',
      this.runningEnv.env,
      '是否开启Debug：',
      this.runningEnv.isDev,
      `使用${localPlatform}的KEY`,
      '配置项：',
      filtedConfig
    )
    this.curPlatform = localPlatform
    var finalConfig = Object.assign(
      {},
      { debug: this.runningEnv.isDev },
      filtedConfig
    )
    window.zhuge.load(useKey, finalConfig)

    // if (window.loginUserId) {
    //     window.zhuge.identify(String(window.loginUserId));
    //     console.log(window.loginUserId);
    // }
  }
  send(data) {
    if (typeof data === 'string') {
      data = {
        name: data
      }
    }
    this.statSend(data)
  }
  /**
   * 标记用户的方法，在后台可以看到具体的属性
   * @param {*} id 唯一标识
   * @param {*} properties 补充说明属性
   */
  identify(id, properties = {}) {
    try {
      window.zhuge.identify(String(id), properties)
    } catch (error) {
      console.error(error)
    }
  }

  statSend(data) {
    const sendFlow = Promise.resolve()
    if (this.interceptor && typeof this.interceptor === 'function') {
      sendFlow.then(() => {
        return this.interceptor()
      })
    }
    sendFlow
      .then(() => {
        // 由于诸葛IO SDK升级，能够设置全局属性，但是为了兼容客户端和维持web的灵活性，还是使用自己维护的globalParams
        let resultParams = {}
        if (
          typeof this.globalParams === 'object' &&
          Object.keys(this.globalParams).length > 0
        ) {
          // TODO: 校验globalParams，key的类型，如果是多层Object，将Object抽出来
          // for (let key in  this.globalParams) {
          //     resultParams[key] = typeof(this.globalParams[key] !== ) ? this.globalParams[key] : undefined;
          // }
          data.properties = Object.assign(
            {},
            this.globalParams,
            data.properties
          )
        }
        data.properties = Object.assign({}, resultParams, data.properties)

        if (
          this.curPlatform === 'yxlApp' &&
          (this.platform.isYixinliApp || this.platform.isCeShiApp)
        ) {
          // 是壹心理App但是指定使用的key不是yxlApp的时候，不要给客户端代理埋点
          // app代理埋点
          this.bridge.call('stat', data)
        } else {
          // web埋点
          // if (this.platform.isMobile) {
          //
          // } else {
          //
          // }
          window.zhuge.track(data.name, data.properties)
        }
      })
      .catch(e => {
        console.log(e)
      })
  }
}

// window.yxl = window.yxl || {};
// window.yxl.stat = stat;
// return stat;

export default stat
export { stat }

/**
 * ext:
 * stat.init({bridge: new Bridge()});
 * stat.send({name:"事件名称",properties{key:value}});
 */



// WEBPACK FOOTER //
// ./src/frontend-lib/lib/stat/Stat.js